/** Cast状態を更新（Play）. */
export const CAST_PLAY = "CAST_PLAY";

/** Cast状態を更新（Idle）. */
export const CAST_IDLE = "CAST_IDLE";

/** Cast状態を更新（Stop）. */
export const CAST_STOP = "CAST_STOP";